/**
 * Builds the property dashboard overview URL from the properties base path and a listing alias.
 * This is the canonical landing route for a property; the bare `/properties/<alias>` path has no
 * route and 404s, so the `/dashboard/overview` suffix is owned here to keep every link consistent.
 * An empty alias falls back to the properties index, so a malformed `/properties//dashboard/overview`
 * URL is impossible by construction.
 */
export default function getPropertyDashboardOverviewUrl(propertiesBasePath: string, listingAlias: string) {
  return listingAlias ? `${propertiesBasePath}/${listingAlias}/dashboard/overview` : propertiesBasePath;
}
